/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowCraftBeerBreweryTourTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowCraftBeerBreweryTour,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Explore Local Breweries!",
    "Craft Beer Brewery Tour Awaits!",
    "Sip and Savor Together!",
  ],
  title: "Craft Beer Brewery Tour",
  description: "Organize a fun craft beer brewery tour.",
  longDescription:
    "Gather your friends for an exciting craft beer brewery tour! Choose a date, decide on breweries to visit, and plan transportation!",
  emoji: "🍺",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Craft Beer Brewery Tour",
          emoji: "🍺",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we go on the craft beer brewery tour?",
          emoji: "📅",
          completeAction: {
            question: "Decide on breweries to visit?",
            description: "What breweries should we include in our tour?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What breweries should we consider?",
                emoji: "🏭",
                completeAction: {
                  question: "Decide on transportation options?",
                  description:
                    "What transportation options should we plan for the tour?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What transportation should we bring?",
                      emoji: "🚐",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Cheers to Great Brews!",
    outroDescription:
      "Your craft beer brewery tour plans are set! Enjoy the tastings!",
  },
};
